<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="empty" *ngIf="items && !items.length">EMPTY SUB MENU</div>
  <div class="header">
    <div class="header-menu" *onlyForScreens="['desktop', 'tablet']">
      <ng-container *ngFor="let link of items">
        <div class="menu-item" [appStoryblok]="link._editable">
          <a
            [routerLink]="link.link | storyblokLinkUrl"
            appButton
            name="{{ link.buttonText | lowercase }}"
            location="sub-menu"
            color="simple-gray"
            [routerLinkActive]="'bc-simple-primary'"
            [routerLinkActiveOptions]="{ exact: true }"
            height="1"
            size="1"
          >
            <span
              ><span class="width-holder">{{ link.buttonText }}</span
              >{{ link.buttonText }}</span
            >
          </a>
        </div>
      </ng-container>
    </div>
    <div class="header-menu" *onlyForScreens="['mobile']">
      <ng-container *ngFor="let link of items">
        <div class="menu-item" [appStoryblok]="link._editable">
          <a
            [routerLink]="link.link | storyblokLinkUrl"
            appButton
            name="{{ link.buttonText | lowercase }}"
            location="sub-menu"
            color="simple-gray"
            [routerLinkActive]="'bc-simple-primary'"
            [routerLinkActiveOptions]="{ exact: true }"
            height="1"
            size="1"
            spacing="1"
          >
            <span
              ><span class="width-holder">{{ link.buttonText }}</span
              >{{ link.buttonText }}</span
            >
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</app-block-wrapper>
